import axios from 'axios'
import store from '../../store/index'
import common from './common'
import router from '../../router/index'
import {Message} from 'element-ui'

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做某事
    // console.log(common.NO_HEADER_URL.indexOf(config.url))
    if (!common.NO_HEADER_URL.includes(config.url)) {
        config.headers.token = store.getters.getToken
        let city = store.getters.getCity
        config.headers.city = city.citycode
    }
    // console.log(config)
    return config
}, function (error) {
    // 请求错误时做些事
    return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    if (response.data.code === 403) {
        store.commit('logout')
        Message.error('请登录')
        router.replace('/')
    }
    // 对响应数据做些事
    return response
}, function (error) {
    // 请求错误时做些事
    return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/assets/js/axios-config.js